import { Bill } from "../../../core/models/bills/bills.model";
import { LastBillsTableRow } from "../../../core/models/lastBills/lastBills.model";
import { formatStringDate } from "../../dateUtils/formatDate.util";
import { formatNumber } from "../../formatters/formatters.util";

const formatLastBills = (
  bills: Bill[],
  isAdmin: boolean
): LastBillsTableRow[] => {
  return bills.map(
    ({
      IdContratoDocumento,
      FechaFactura,
      FechaDesde,
      FechaHasta,
      ImporteTotal,
      Estado_Fac,
      Entorno,
    }) => {
      return {
        id: IdContratoDocumento,
        service: Entorno,
        billDate: formatStringDate(FechaFactura),
        period: (FechaDesde && FechaHasta) 
        ? `${formatStringDate(FechaDesde)} - ${formatStringDate(FechaHasta)}` 
        : '- - -',
        amount: `${formatNumber(+ImporteTotal)} €`,
        state: Estado_Fac,
      };
    }
  );
};

export { formatLastBills };
